import { syncGameVisibility } from '@/data/games'

let source = null
let refCount = 0
let retryTimer = null
let retryMs = 3000
const RETRY_MAX_MS = 60000

function clearRetry () {
  if (retryTimer) {
    clearTimeout(retryTimer)
    retryTimer = null
  }
}

function scheduleRetry () {
  clearRetry()
  retryTimer = setTimeout(() => {
    if (refCount > 0) connect()
  }, retryMs)
  retryMs = Math.min(RETRY_MAX_MS, Math.floor(retryMs * 1.6))
}

function connect () {
  if (typeof EventSource === 'undefined') return
  source?.close()
  try {
    source = new EventSource('/lgw/games/config-stream')
  } catch (_) {
    source = null
    if (refCount > 0) scheduleRetry()
    return
  }
  source.addEventListener('game_config', () => {
    syncGameVisibility()
  })
  source.onopen = () => {
    clearRetry()
    retryMs = 3000
  }
  source.onerror = () => {
    // 404/网关未就绪时不要每 3 秒狂刷；指数退避
    source?.close()
    source = null
    if (refCount > 0) scheduleRetry()
  }
}

export function startGameConfigPush () {
  refCount += 1
  if (refCount === 1) {
    retryMs = 3000
    connect()
  }
}

export function stopGameConfigPush () {
  refCount = Math.max(0, refCount - 1)
  if (refCount === 0) {
    clearRetry()
    source?.close()
    source = null
  }
}
